<template>
  <content-layout>
    <div class="content">
      <div class="flex-row">
        <CySkeletonLine width="270" height="360" class="flex-no-shrink" style="margin-right: 24px;"></CySkeletonLine>
        <div>
          <CySkeletonLine width="728" height="30"></CySkeletonLine>
          <CySkeletonLine width="264" height="20" style="margin-top: 27px;"></CySkeletonLine>
          <CySkeletonLine width="575" height="20" style="margin-top: 15px;"></CySkeletonLine>
          <div class="flex-row" style="margin-top: 41px;">
            <CySkeletonLine width="32" height="20" class="flex-no-shrink" style="margin-right: 20px"></CySkeletonLine>
            <div class="flex-row flex-wrap">
              <CySkeletonLine width="200" height="42"
                v-for="i,index in new Array(8).fill({})" :key="index"
                style="margin-right:12px;margin-bottom:12px">
              </CySkeletonLine>
            </div>
          </div>
          <div class="flex-row" style="margin-top: 41px;">
            <CySkeletonLine width="32" height="20" class="flex-no-shrink" style="margin-right: 20px"></CySkeletonLine>
            <div  class="flex-row flex-wrap">
              <CySkeletonLine width="100" height="42"
                v-for="i,index in new Array(5).fill({})" :key="index"
                style="margin-right:12px;margin-bottom:12px">
              </CySkeletonLine>
            </div>
          </div>
          <CySkeletonLine width="245" height="20" style="margin-top: 40px;margin-left:50px"></CySkeletonLine>
          <CySkeletonLine width="200" height="44" style="margin-top: 20px;margin-left:50px"></CySkeletonLine>
        </div>
      </div>
      <CySkeletonLine width="1062" height="1" style="margin-top: 60px;"></CySkeletonLine>
      <div class="flex-row">
        <CySkeletonLine width="64" height="36"
        v-for="i,index in new Array(3).fill({})" :key="index"
        style="margin-right:60px;margin-top:24px;">
      </CySkeletonLine>
      </div>
      <CySkeletonLine width="64" height="20" style="margin-top:40px;"></CySkeletonLine>
      <CySkeletonLine width="980" height="72" style="margin-top:12px;"></CySkeletonLine>

      <CySkeletonLine width="64" height="20" style="margin-top:40px;"></CySkeletonLine>
      <CySkeletonLine width="750" height="48" style="margin-top:12px;"></CySkeletonLine>

      <CySkeletonLine width="1062" height="540" style="margin-top:20px;"></CySkeletonLine>
      <CySkeletonLine width="1062" height="540" style="margin-top:20px;"></CySkeletonLine>

      <CySkeletonLine width="64" height="20" style="margin-top:40px;"></CySkeletonLine>
      <CySkeletonLine width="580" height="44" style="margin-top:12px;"></CySkeletonLine>

      <CySkeletonLine width="64" height="20" style="margin-top:40px;"></CySkeletonLine>
      <CySkeletonLine width="980" height="196" style="margin-top:12px;"></CySkeletonLine>

      <CySkeletonLine width="64" height="20" style="margin-top:40px;"></CySkeletonLine>
      <CySkeletonLine width="334" height="196" style="margin-top:12px;margin-bottom:102px;"></CySkeletonLine>
    </div>
  </content-layout>
</template>

<script setup lang="ts">

</script>

<style scoped lang="less">
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content {
  .line {
    width: 1062px;
    height: 1px;
    background: var(--vt-c-white-soft);
    margin-top: 60px;
    margin-bottom: 24px;
  }
  nav {
    .nav-header {
      display: flex;
      .nav-list {
        margin-right: 60px;
        cursor: pointer;
        font-size: 16px;
        color: @liner-text-color;
        padding-bottom: 20px;
      }
      .active {
        color: @common-text-color;
        font-weight: 500;
        position: relative;
        &::after {
          content: '';
          overflow: hidden;
          display: block;
          position: relative;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 32px;
          height: 4px;
          background: #000000;
        }
      }
    }
  }
}
.notify{
  height: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #1A1A1A;
  line-height: 20px;
  margin-top: 40px;
  margin-bottom: 12px;
}
.notify-name{
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-bottom: 8px;
}
.notify-value{
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}
.nav-content{
  margin-bottom: 100px;
}

.announcet-dialog {
  :deep(.dialog-box-content) {
    overflow-y: scroll;
    .tile-announcet-detail {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  :deep(.dialog-footer) {
    .btn {
      width: 100%;
      margin-top: 20px;
      .btn-confirm {
        width: 100% !important;
        height: 54px !important;
        line-height: 54px;
      }
    }
  }
}
</style>
